import { SegmentService } from './segment';

const segmentService = new SegmentService();

export { segmentService };
export * from './segments';
